<div
  class="phx-page-header"
  [ngClass]="{
    'phx-page-header-with-shadow': !showBorder && !shouldHideShadowAndBorder,
    'phx-page-header-with-border': showBorder && !shouldHideShadowAndBorder,
    'phx-page-header-with-tabs': tabs?.length,
    'phx-page-header-primary': isFormHeader,
    'd-none': isHidden
  }"
>
  <div class="phx-page-header-top">
    <div class="phx-page-header-title">
      <div class="page-title-container" data-testid="page-title-container">
        <button
          *ngIf="!isFormHeader; else crossIcon"
          class="new-hamburger header-left-action hide show-sm pos-absolute"
          phx-icon-button
          phxIconButtonSize="extra-large"
          [phxIcon]="HamburgerIcon"
        ></button>

        <div *ngIf="!isMobileView" class="tablet-breadcrumb-container inherit-width" [class.show-group-filter]="showGroupFilter">
          <phx-breadcrumb
            *ngIf="!isLoading; else titleSkeleton"
            [class.only-title]="breadcrumb?.length === 1"
            [phxOnBold]="isFormHeader"
          >
            <ng-container *ngFor="let item of breadcrumb">
              <phx-breadcrumb-item
                [phxText]="item.title"
                [phxLink]="item.commands"
                [phxBadgeText]="item.customTag?.text"
                [phxBadgeContrast]="item.customTag?.contrast || phxBadgeContrastDefaultValue"
                [phxBadgeIntent]="item.customTag?.intent || phxBadgeIntentDefaultValue"
              ></phx-breadcrumb-item>
            </ng-container>
          </phx-breadcrumb>
          <ng-template #titleSkeleton>
            <phx-skeleton phxWidth="120px" phxHeight="20px" phxShape="rounded"></phx-skeleton>
          </ng-template>
          <div *ngIf="isGroupFilterEnabled" class="group-filter-container" [class.d-none]="isLoading || !showGroupFilter">
            <ng-container [ngTemplateOutlet]="groupFilterTemplate"></ng-container>
          </div>
        </div>
        <ng-template #triggerRef let-data>
          <div
            phx-tooltip
            phxPlacement="bottom"
            [phxContent]="selectedGroupsTooltipContent"
            [phxTooltipContext]="data.selectedItems"
            [phxTrigger]="data.selectedItems?.length > 1 ? 'hover' : 'none'"
            class="group-filter-custom-label"
            [class.active]="data.isOpen"
            [class.selected]="data.selectedSize > 0"
          >
            <div class="truncate-text-overflow">
              <ng-container *ngIf="data.selectedSize === 0" i18n>All Groups</ng-container>
              <ng-container *ngIf="data.selectedSize === 1">{{ data.selectedItems[0].label }}</ng-container>
              <ng-container *ngIf="data.selectedSize > 1">
                {{ data.selectedSize }} <ng-container i18n>Groups</ng-container>
              </ng-container>
            </div>
            <i phx-icon [phxIcon]="ChevronDownIcon" size="24" color="currentColor"></i>
          </div>

          <ng-template #selectedGroupsTooltipContent let-groups>
            <div *ngFor="let group of groups | slice : 0 : 10">{{ group.label }}</div>
            <div *ngIf="groups.length > 10">+{{ groups.length - 10 }} more</div>
          </ng-template>
        </ng-template>
        <div
          *ngIf="isMobileView"
          class="mobile-title-section phx-web-type-title-medium"
          [class.right-header-action-hidden]="!mobileMenuItems?.length && !(isFormHeader && (onFormCancel || onFormSubmit))"
        >
          <div *ngIf="showGroupFilter" class="group-filter-container">
            <ng-container [ngTemplateOutlet]="groupFilterTemplate"></ng-container>
          </div>
          <ng-container *ngIf="showBreadcrumb">
            <div
              *ngIf="isMainPage; else mobileBreadcrumbs"
              class="mobile-small-title phx-web-type-body-extra-small truncate-text-overflow"
            >
              <ng-container *ngIf="showGroupFilter; else withoutGroupFilter">
                <span class="mobile-title-text">{{ breadcrumb[0]?.title }}</span>
                <i phx-icon [phxIcon]="BulletIcon" [size]="12" color="currentColor"></i>
                <span class="group-filter-label overflow-xy-hidden">{{ groupFilterLabel }}</span>
              </ng-container>
              <ng-template #withoutGroupFilter>
                <span *ngIf="tabs?.length" class="mobile-title-text">{{ breadcrumb[0]?.title }}</span>
              </ng-template>
            </div>

            <ng-template #mobileBreadcrumbs>
              <phx-breadcrumb *ngIf="!isLoading" phxSize="small" [phxAlignCenter]="true" [phxOnBold]="isFormHeader">
                <phx-breadcrumb-item
                  *ngFor="let item of tabs?.length ? breadcrumb : (breadcrumb | slice : 0 : -1)"
                  [phxText]="item.title"
                  [phxLink]="item.commands"
                ></phx-breadcrumb-item>
              </phx-breadcrumb>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="tabs?.length; else titleForDetailView">
            <div class="mobile-select-trigger" (click)="setTabsDropdownForMobile(true)">
              <span>{{ selectedTab?.label }}</span>
              <i phx-icon [phxIcon]="ChevronDownIcon" [size]="24" color="currentColor"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="isMobileView">
            <ng-container *ngTemplateOutlet="mobileTabs"></ng-container>
          </ng-container>

          <ng-template #titleForDetailView>
            <span class="phx-web-type-title-medium truncate-text-overflow d-block">{{ titleForMobileView }}</span>
          </ng-template>
        </div>

        <button
          *ngIf="mobileMenuItems?.length || isAdminSwitcherVisible"
          class="hide show-sm header-right-action pos-absolute"
          phx-icon-button
          phxIconButtonSize="extra-large"
          [phxIcon]="EllipsesIcon"
          [phxDropdownFor]="dropdownMenu"
          phxTrigger="click"
        ></button>

        <ng-template #crossIcon>
          <button
            *ngIf="isFormHeader && onFormCancel"
            class="hide show-sm pos-absolute header-left-action"
            phx-icon-button
            phxIconButtonType="on-bold"
            phxIconButtonSize="extra-large"
            [phxIcon]="CloseIcon"
            (click)="onFormCancel()"
          ></button>
        </ng-template>

        <button
          *ngIf="isFormHeader && onFormSubmit"
          class="hide show-sm pos-absolute header-right-action"
          phx-icon-button
          phxIconButtonType="on-bold"
          phxIconButtonSize="extra-large"
          [phxIcon]="CheckIcon"
          [disabled]="isSubmitActionDisabled"
          (click)="onFormSubmit()"
        ></button>

        <phx-dropdown #dropdownMenu>
          <phx-menu>
            <ng-container *ngFor="let item of mobileMenuItems">
              <phx-menu-item
                *ngIf="item.shouldShowItem"
                (click)="!item.isDisabled && item.click()"
                [class.no-events]="item.isDisabled"
              >
                <i *ngIf="item.iconSrc" nz-icon class="mr-10">
                  <img [src]="item.iconSrc" [class.filter-grey-30]="item.isDisabled" />
                </i>
                <div class="d-inline-flex flex-col" [class.grey-30]="item.isDisabled">
                  <span class="d-block">{{ item.label }}</span>
                  <span *ngIf="item.subtext" class="d-block subtitle">{{ item.subtext }}</span>
                </div>
              </phx-menu-item>
            </ng-container>
            <phx-menu-item *ngIf="isAdminSwitcherVisible" (click)="onAdminSwitcherClick()">{{ adminSwitcherTextContent }}</phx-menu-item>
          </phx-menu>
        </phx-dropdown>
      </div>
    </div>

    <div #headerExtra class="header-extra" [class.should-hide-actions-on-footer]="shouldHideMobileFooter">
      <!-- Displays page actions -->
      <ng-content></ng-content>
      <ng-container *ngTemplateOutlet="rightExtrasTempRef"></ng-container>
      <button
        *ngIf="isAdminSwitcherVisible"
        phx-button
        phx-tooltip
        phxButtonRole="secondary"
        phxTooltipSize="small"
        phxPlacement="bottomRight"
        [phxPrefixIcon]="isAdminPage ? DashboardIcon : PersonGearIcon"
        [phxContent]="adminSwitcherTextContent"
        (click)="onAdminSwitcherClick()"
      ></button>
    </div>
  </div>

  <div *ngIf="tabs.length" class="phx-page-header-footer hide-sm">
    <phx-tabset
      [phxTabType]="isFormHeader ? 'primary' : 'secondary'"
      [phxActiveTabIndex]="activeTabIndex"
      data-testid="tabs-container"
      [phxShouldMatchExactLink]="shouldMatchExactLink"
      [phxMatchUrl]="useNzLinkRouter"
      (phxActiveTabIndexChange)="onTabIndexChanged($event)"
    >
      <ng-container *ngFor="let tab of tabs; trackBy: trackByTab">
        <phx-tab
          *ngIf="tab.shouldNavItemShow"
          [phxShowSeparator]="tab.seperator"
          [phxLink]="useNzLinkRouter ? tab.link : null"
          (phxTabClick)="onTabChanged(tab.value)"
          [phxDisableAutoSelect]="tab.disableAutoSelect"
          [phxDisableQueryParamMode]="tab.disableQueryParamMode"
        >
          <ng-container *ngIf="tab.template" [ngTemplateOutlet]="tab.template"></ng-container>
          <span *ngIf="tab.label" class="phx-tab-label">{{ tab.label }}</span>
          <phx-badge
            *ngIf="notificationCountString(tab.notificationCount)"
            [phxText]="notificationCountString(tab.notificationCount)"
            [phxContrast]="isFormHeader ? 'low' : 'high'"
          ></phx-badge>
          <phx-badge *ngIf="badgeText(tab)" [phxText]="badgeText(tab)" [phxContrast]="isFormHeader ? 'low' : 'high'"></phx-badge>
          <ng-container *ngIf="tab.suffixTemplate" [ngTemplateOutlet]="tab.suffixTemplate"></ng-container>
        </phx-tab>
      </ng-container>
    </phx-tabset>
  </div>
</div>

<ng-template #groupFilterTemplate>
  <global-groups-multi-select-filter
    placeholder="All Groups"
    [phxImplementation]="true"
    [dropdownWidth]="360"
    [fullWidth]="true"
    [showPrefixIcon]="false"
    [isDisabled]="groupsFilterDisabled$ | async"
    [footerThreshold]="1"
    [dialogOpen]="mobileDialogOpen"
    [showMobileView]="isMobileView"
    (dialogClose)="closeMobileDialog()"
    (selectedOptionsChanged)="onSelectedOptionsChanged($event)"
    [customTriggerButtonTemplate]="triggerRef"
  ></global-groups-multi-select-filter>
</ng-template>

<ng-template #mobileTabs>
  <phx-mobile-select
    [phxOptionsListClassName]="showGroupFilter ? 'mobile-select-custom-styles has-group-option' : 'mobile-select-custom-styles'"
    [ngModel]="selectedTab?.value"
    (ngModelChange)="onTabChanged($event)"
    [(phxOpen)]="isTabsDropdownForMobileOpen"
    [phxHeaderTitle]="breadcrumb && breadcrumb[0]?.title"
    [phxFullHeight]="false"
    [phxAllowSearch]="false"
    [phxAllowClear]="false"
  >
    <ng-container *ngIf="showGroupFilter">
      <phx-select-option label="Groups" value="Groups" i18n-label [phxOptionTemplate]="groupOption"></phx-select-option>
      <phx-select-option label="test" value="test" [phxOptionTemplate]="groupOptionDivider"></phx-select-option>

      <ng-template #groupOption>
        <div class="menu-item-groups" (click)="onGroupsItemClick($event)">
          <span i18n>Groups</span>
          <phx-badge phxIntent="accent" phxContrast="low" [phxCount]="selectedGroupsCount"></phx-badge>
          <i phx-icon [phxIcon]="ChevronRightIcon"></i>
        </div>
      </ng-template>

      <ng-template #groupOptionDivider>
        <phx-divider></phx-divider>
      </ng-template>
    </ng-container>

    <phx-select-option
      *ngFor="let item of tabs"
      [label]="item.label"
      [value]="item.value"
      [data]="item"
      [phxOptionTemplate]="mobileSelectOption"
    ></phx-select-option>

    <ng-template #mobileSelectOption let-opt>
      <a
        *ngIf="useNzLinkRouter"
        class="mobile-tabs-link"
        [routerLink]="opt.data?.shouldHandleMatrixParams ? null : opt.data?.link"
        [queryParamsHandling]="opt.data?.disableQueryParamMode ? '' : 'merge'"
        (click)="onTabChanged(opt.value)"
      >
        {{ opt.label }}
      </a>

      <span *ngIf="!useNzLinkRouter" class="mobile-tabs-link" (click)="onTabChanged(opt.value)">
        {{ opt.label }}
      </span>
    </ng-template>
  </phx-mobile-select>
</ng-template>
